// import { CaretDownOutlined } from '@ant-design/icons';
// import Logo from '@assets/images/MySG.jpeg';
//import { useLingui } from '@lingui/react';

import { styled } from 'styled-components';
import { Menu } from '~/components/ui/menu';
//import { useAuth } from '~/helpers/store/auth';
//import { classic } from '~/themes/classic';

function GameHeader() {
  //   const { payload } = useAuth();
  //   const { i18n } = useLingui();

  return (
    <Container>
      <Menu />
    </Container>
  );
}

export default GameHeader;

const Container = styled.div`
  align-items: center;
  display: flex;
  padding: 5px;
  width: 100%;
  z-index: 2;

  @media screen and (max-width: 450px) {
    padding: 5px;
  }
  @media screen and (max-height: 800px) {
    padding: 5px;
  }
  @media screen and (max-height: 450px) {
    padding: 5px;
  }
`;
